import React, { useState } from 'react'
import AmbulanceBookingTabs from '../components/ambulance/AmbulanceBookingTabs'
import AmbulanceTypes from '../components/ambulance/AmbulanceTypes'

const AmbulanceBookingPage = ({ dashboardType = 'admin' }) => {
  const [selectedAmbulanceType, setSelectedAmbulanceType] = useState('bls')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  // Loading spinner component
  const LoadingSpinner = () => (
    <div className="flex items-center justify-center py-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      <span className="ml-2 text-gray-600">Loading...</span>
    </div>
  )

  // Error display component
  const ErrorDisplay = ({ error, onRetry }) => (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">Error occurred</h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{error}</p>
          </div>
          {onRetry && (
            <div className="mt-4">
              <button
                onClick={onRetry}
                className="bg-red-100 hover:bg-red-200 text-red-800 px-3 py-1 rounded text-sm font-medium"
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
         {/* Header */}
         <div className="mb-6 sm:mb-8 w-full">
         </div>

        {/* Error Display */}
        {error && <ErrorDisplay error={error} onRetry={() => setError(null)} />}

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Left Section - Booking Form */}
          <div className="lg:col-span-2">
            <AmbulanceBookingTabs 
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              error={error}
              setError={setError}
            />
          </div>

          {/* Right Section - Information Panels - Responsive */}
          <div className="space-y-6">
            <AmbulanceTypes 
              selectedType={selectedAmbulanceType}
              onTypeSelect={setSelectedAmbulanceType}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AmbulanceBookingPage


